import Angular from "angular";
import _ from "lodash/lodash";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Settings from "../providers/settings.provider";
import Resource from "../model/resource.model";

export var Name = 'Resources';

export class Resources extends Service {
    static Resources = Name;
    static $inject = ['$q', 'Restangular', 'CacheFactory', 'settings'];

    create() {
        // NOOP.
    }

    all() {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('resources', this.settings.branch.id)
            .withHttpConfig({cache: this.CacheFactory.get('http')})
            .getList()
            .then((data)=> {
                data = _(data)
                    .map((resourceData)=> {
                        return this.Restangular.copy(new Resource(resourceData));
                    })
                    .sortBy(resource => resource.name)
                    .value();

                defer.resolve(data);
            })
            .catch((err)=> {
                defer.reject(err);
            });

        return defer.promise;
    }

}

var ResourcesModule = Angular.module('resources-service', ['restangular', Settings.name]);

new Loader(ResourcesModule)
    .load(Resources);

export default ResourcesModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/resources.service.js